/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props) {
  return {
    variables: {
      board_ids: props.boardId,
    },
    pause: !Array.isArray(props.boardId),
    requestPolicy: 'cache-and-network',
  }
}
